<template>
  <Badge :variant="PAYMENT_STATUS_VARIANT[status]" :size="size" :class="props.class">
    {{ t(`${labelPrefix}.${status}`) }}
  </Badge>
</template>

<script setup lang="ts">
import Badge from '@/components/Badge.vue';
import { PaymentStatus } from '@/entities/payments/payment-status.enum';
import type { BadgeVariant } from '@carvia/theme/lib/cva/badge';
import { computed, type HTMLAttributes } from 'vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
  defineProps<{
    status: PaymentStatus;
    size?: 'sm' | 'md';
    short?: boolean;
    class?: HTMLAttributes['class'];
  }>(),
  {
    size: 'sm',
    short: false,
  },
);

const { t } = useI18n();

const labelPrefix = computed(() => (props.short ? 'shortPaymentStatus' : 'paymentStatus'));

const PAYMENT_STATUS_VARIANT: Record<PaymentStatus, BadgeVariant> = {
  [PaymentStatus.PENDING]: 'warning',
  [PaymentStatus.AUTHORIZED]: 'warning',
  [PaymentStatus.CAPTURE_REQUESTED]: 'warning',
  [PaymentStatus.PAID]: 'success',
  [PaymentStatus.CANCELLED]: 'problem',
};
</script>
